module.exports = __webpack_public_path__ + "img/section4Logo3.0861af55.png";